var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "redo_svg2__a",
    x1: 53.1,
    x2: 205.1,
    y1: 145.4,
    y2: 50.4,
    gradientTransform: "matrix(-1 0 0 1 200 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M87.1 64.5H167l-35.1-35.1c-3.7-3.7-3.7-9.9 0-13.7 3.7-3.7 9.9-3.7 13.7 0l51.6 51.6c3.7 3.7 3.7 9.9 0 13.7l-51.6 51.6c-1.9 1.9-4.4 2.8-6.8 2.8s-4.9-.9-6.8-2.8c-3.7-3.7-3.7-9.9 0-13.7l35.1-35.1H87.2c-37.4 0-67.8 30.5-67.8 67.8v25.8c0 5.3-4.4 9.7-9.7 9.7S0 182.7 0 177.4v-25.8c0-48 39.1-87.1 87.1-87.1",
    style: {
      fill: "url(#redo_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgRedo;